"use strict";

require("core-js/modules/es.reflect.construct.js");
require("core-js/modules/es.array.iterator.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.string.iterator.js");
require("core-js/modules/es.weak-map.js");
require("core-js/modules/web.dom-collections.iterator.js");
require("core-js/modules/es.object.define-property.js");
require("core-js/modules/es.object.get-own-property-descriptor.js");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require("core-js/modules/es.array.concat.js");
require("core-js/modules/es.regexp.exec.js");
require("core-js/modules/es.string.match.js");
require("core-js/modules/es.array.map.js");
require("core-js/modules/es.function.name.js");
require("core-js/modules/es.array.join.js");
require("core-js/modules/es.array.for-each.js");
require("core-js/modules/web.dom-collections.for-each.js");
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
var _lodash = require("lodash");
var _helpers = require("./helpers");
var _reactRedux = require("react-redux");
var _ui = require("@evidation/ui");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var CSVButton = /*#__PURE__*/function (_Component) {
  function CSVButton() {
    var _this;
    (0, _classCallCheck2["default"])(this, CSVButton);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, CSVButton, [].concat(args));
    (0, _defineProperty2["default"])(_this, "invalidColumnName", function (column) {
      _this.props.throwError("Invalid Column Name for column: ".concat(JSON.stringify(column)));
    });
    (0, _defineProperty2["default"])(_this, "downloadCSV", function () {
      var filename = _this.props.filename || 'export.csv';
      var csv = _this.formatCSVData();
      if (!csv.match(/^data:text\/csv/i)) {
        csv = 'data:text/csv;charset=utf-8,' + csv;
      }
      var link = document.createElement('a');
      link.setAttribute('href', csv);
      link.setAttribute('download', filename);
      link.click();
    });
    (0, _defineProperty2["default"])(_this, "formatCSVData", function () {
      var counter = 0;
      var result = '';
      var data = _this.getRows();

      // The CSV headers should be the human readable labels provided
      var labels = _this.props.columns.map(function (column) {
        return column.label || column.name || _this.invalidColumnName(column);
      });
      result += labels.join(',');
      result += '\n';
      var keys = _this.props.columns.map(function (column) {
        return column.name || _this.invalidColumnName(column);
      });
      data.forEach(function (item) {
        keys.forEach(function (key) {
          if (counter > 0 && key !== keys[0]) result += ',';
          result += item[key];
          counter++;
        });
        result += '\n';
      });
      return result;
    });
    (0, _defineProperty2["default"])(_this, "getColumns", function () {
      var columns = [];
      _this.props.columns.map(function (column) {
        columns.push(column.name || (0, _helpers.slugify)(column));
      });
      return columns;
    });
    (0, _defineProperty2["default"])(_this, "getRows", function () {
      var columns = _this.getColumns();
      var rows = [];
      var formattedRow;
      _this.props.data.map(function (row) {
        formattedRow = {};
        columns.map(function (column) {
          formattedRow[column] = row[column] || '';
        });
        rows.push(formattedRow);
      });
      return rows;
    });
    return _this;
  }
  (0, _inherits2["default"])(CSVButton, _Component);
  return (0, _createClass2["default"])(CSVButton, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react["default"].createElement(_ui.Button, {
        onClick: this.downloadCSV,
        variant: "secondary"
      }, "Download as CSV");
    }
  }]);
}(_react.Component);
var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    throwError: function throwError(payload) {
      return dispatch({
        type: 'ATC/ERROR',
        payload: payload
      });
    }
  };
};
var _default = exports["default"] = (0, _reactRedux.connect)(null, mapDispatchToProps)(CSVButton);